export default [
    {
        path: 'aplicacao-campanha',
        component: () => import(/* weimunizacaockChunkName: 'imunizacao-aplicacao-campanha' */ '@/views/imunizacao/aplicacao-campanha/Index'),
        redirect: 'aplicacao-campanha/index',
        children: [
            {
                name: 'imunizacao-aplicacao-campanha-index',
                path: 'index',
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-aplicacao-campanha' */ '@/views/imunizacao/aplicacao-campanha/List.vue'),
            },
            {
                name: 'imunizacao-aplicacao-campanha-create',
                path: 'create/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-aplicacao-campanha' */ '@/views/imunizacao/aplicacao-campanha/Form.vue'),
            },
        ],
    },
]